import type { Entry } from "contentful";
import type {
   ContentfulAccordion,
   ContentfulAdventCalendarSlot,
   ContentfulArticle,
   ContentfulImageLink,
   ContentfulImageLinkToUrl,
   ContentfulRecipe,
   ContentfulTeaser,
   ContentfulUsp
} from "../types/cmsTypes";
import type {
   TypeAccordionSkeleton,
   TypeAdventCalendarSlotSkeleton,
   TypeImageLinkSkeleton,
   TypeImageLinkToUrlSkeleton,
   TypeRecipeSkeleton,
   TypeUspSkeleton,
   TypeV2_articleSkeleton
} from "../types/contentful";

export type CmsListEntry =
   | Entry<
        | TypeRecipeSkeleton
        | TypeAdventCalendarSlotSkeleton
        | TypeAccordionSkeleton
        | TypeUspSkeleton
        | TypeImageLinkSkeleton
        | TypeImageLinkToUrlSkeleton
        | TypeV2_articleSkeleton,
        "WITHOUT_UNRESOLVABLE_LINKS",
        string
     >
   | undefined;

export const isTeaser = (entry: CmsListEntry): entry is ContentfulTeaser => {
   return isArticle(entry) || isImageLink(entry) || isImageLinkToUrl(entry);
};

export const isImageLink = (entry: CmsListEntry): entry is ContentfulImageLink => {
   return entry?.sys?.contentType?.sys?.id === "imageLink";
};

export const isImageLinkToUrl = (entry: CmsListEntry): entry is ContentfulImageLinkToUrl => {
   return entry?.sys?.contentType?.sys?.id === "imageLinkToUrl";
};

export const isArticle = (entry: CmsListEntry): entry is ContentfulArticle => {
   return entry?.sys?.contentType?.sys?.id === "v2_article";
};

export const isRecipe = (entry: CmsListEntry): entry is ContentfulRecipe => {
   return entry?.sys?.contentType?.sys?.id === "recipe";
};

export const isAdventCalendarSlot = (entry: CmsListEntry): entry is ContentfulAdventCalendarSlot => {
   return entry?.sys?.contentType?.sys?.id === "adventCalendarSlot";
};

export const isAccordion = (entry: CmsListEntry): entry is ContentfulAccordion => {
   return entry?.sys?.contentType?.sys?.id === "accordion";
};

export const isUsp = (entry: CmsListEntry): entry is ContentfulUsp => {
   return entry?.sys?.contentType?.sys?.id === "usp";
};
